import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AlertCircle, CheckCircle } from "lucide-react";
import axios from "axios";
import Navbar from "@/components/Navbar";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      // Same outcome whether or not the email is registered — don't leak account existence.
      setSent(true);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <div className="section-container py-16 flex items-center justify-center">
        <div className="w-full max-w-md">
          <div className="bg-white border border-slate-200 rounded-xl p-8 shadow-sm">
            <div className="text-center mb-8">
              <h1 className="text-2xl font-black text-[#003366] mb-2">Forgot Password?</h1>
              <p className="text-[#64748B] text-sm">Enter your email and we'll send you a reset link</p>
            </div>

            {error && (
              <div className="flex items-center gap-2 bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-lg mb-5" data-testid="forgot-password-error">
                <AlertCircle size={16} />
                {error}
              </div>
            )}

            {sent ? (
              <div className="flex items-start gap-2 bg-green-50 border border-green-200 text-green-800 text-sm p-4 rounded-lg" data-testid="forgot-password-sent">
                <CheckCircle size={18} className="shrink-0 mt-0.5" />
                <span>If that email is registered, we've sent a password reset link. Check your inbox — the link expires in 45 minutes.</span>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
                <div>
                  <label className="block text-sm font-semibold text-[#0F172A] mb-1.5">Email Address</label>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="input-field"
                    placeholder="you@example.com"
                    data-testid="forgot-password-email-input"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="btn-primary w-full !py-3 disabled:opacity-50"
                  data-testid="forgot-password-submit-btn"
                >
                  {loading ? "Sending..." : "Send Reset Link"}
                </button>
              </form>
            )}

            <div className="mt-6 text-center text-sm text-[#64748B]">
              <Link to="/login" className="text-[#003366] font-semibold hover:underline" data-testid="forgot-password-back-to-login">
                Back to Sign In
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
